import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import Layout from 'shared/container/Layout';
import { PageError } from 'shared/components';
import LoadableComponent from 'shared/components/LoadableComponent';

const JobList = LoadableComponent(() => import('./Routes/JobList'));
const JobDetail = LoadableComponent(() => import('./Routes/JobDetail'));

const Job: React.FC<RouteComponentProps> = (props) => {
  const { match } = props;

  return (
    <Layout textHeader="รายการงานขนส่ง">
      <Switch>
        <Route exact path={`${match.path}/detail/:id`} component={JobDetail} />
        <Route exact path={`${match.path}`} component={JobList} />
        <Route component={PageError} />
      </Switch>
    </Layout>
  );
};

export default Job;
